import React, {useRef, useState, useCallback, useEffect} from 'react';
import { connect } from "react-redux";

const TOTAL_WIDTH = 40;

function VolumeBox({track, rackTrack, volume, id, onVolumeChange, min=-40, max=4, width=TOTAL_WIDTH, display, onVolumeChange2}) {
    const [isMouseDown, setIsMouseDown] = useState(false);
    const ref = useRef(undefined);
    let style = {
        width: getWidth(volume, min, max, width)
    };

    const getId = () => {
        if (id) {
            return id;
        }
        return 'volume-' + rackTrack.trackNumber + '-' + track.trackNumber;
    };

    const onMouseDown = useCallback((e) => {
        e.stopPropagation();
        let newVolume = getVolumeFromEvent(e, getId(), min, max, width, ref);
        if (onVolumeChange) {
            onVolumeChange(newVolume);
        } else {
            track.volumeParameter.set(newVolume, true);
        }

        setIsMouseDown(true);
    }, [track, setIsMouseDown]);

    const onMouseMove = useCallback((e) => {
        e.stopPropagation();
        if (!isMouseDown) {
            return;
        }
        let newVolume = getVolumeFromEvent(e, getId(), min, max, width, ref);
        if (onVolumeChange) {
            onVolumeChange(newVolume);
        } else {
            track.volumeParameter.set(newVolume);
        }
    }, [track, isMouseDown]);

    const round = (x) => {
        return Math.round(x*10) / 10;
    };

    return (
        <div
          ref={ref}
          style={{width: width + 6}}
          id={getId()}
          onClick={(e) => e.stopPropagation()}
          onMouseUp={(e) => {
              e.stopPropagation();
              setIsMouseDown(false);
          }}
          onMouseLeave={(e) => {
              e.stopPropagation();
              setIsMouseDown(false);
          }}
          onMouseMove={onMouseMove}
          onMouseDown={onMouseDown}
          className="volume-box">
          <div
            style={style}
            className="volume-indicator">
          </div>
          <span
            className="value">{display ? round(display(volume)) : round(volume)} db</span>
        </div>
    );
}

function getVolumeFromEvent(e, id, min, max, width, ref) {
    let rect = ref.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let vol = getVolumeFromX(x, min, max, width);
    if (isNaN(vol)) {
        return -100;
    }
    return vol;
}

function getWidth(volume, min=-40, max=4, width) {
    let ratio = getVolumeRatio(volume, min, max, width);
    return width * Math.pow(ratio, 2) + 4;
}

function getVolumeFromX(x, min=-40, max=4, width) {
    x = Math.min(Math.max(0, x), width);
    let ratio = x / width;
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

function getVolumeRatio(volume, min=-40, max=4) {
    return (volume - min) / (max - min);
}

const mapStateToProps = (state, props) => {
    if (props.track === undefined) {
        return {};
    }
    return {
        volume: props.track.volumeParameter.get()
    };
};
 

export default connect(mapStateToProps, null)(VolumeBox);
